import { useState } from 'react';
import {
  Avatar, Box, CircularProgress, Divider, ListItemIcon, ListItemText, Menu, MenuItem, Typography,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import SocialApi from '../../api/social';
import initials from '../../utils/initials';

// The user's iConnect accounts to switch between, when there is more than one
export function switchableAccounts(session) {
  const accounts = session?.accounts ?? [];
  return accounts.length > 1 ? accounts : [];
}

/**
 * A menu of the user's accounts, the current one checked. Picking another moves the session there and reloads the
 * page without its query (filters may name the old account's ad accounts), so every view loads that account's data
 */
export default function AccountMenu({ accounts, anchorEl, onClose, ...menuProps }) {
  const [switching, setSwitching] = useState(null);
  const [error, setError] = useState(null);

  const pick = async (account) => {
    if (account.current) {
      onClose();
      return;
    }
    setSwitching(account.id);
    setError(null);
    try {
      await SocialApi.switchAccount(account.id);
      window.location.assign(window.location.pathname);
    } catch (e) {
      setError(e.message);
      setSwitching(null);
    }
  };

  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}
          slotProps={{ paper: { sx: { mt: 1, minWidth: 260, maxWidth: 360, borderRadius: 2 } } }} {...menuProps}>
      <Typography variant="overline" color="text.secondary" component="div" sx={{ px: 2, pt: 0.5 }}>
        Switch account
      </Typography>
      {accounts.map((account) => (
        <MenuItem key={account.id} onClick={() => pick(account)} disabled={switching !== null}
                  selected={account.current} sx={{ py: 1, gap: 1.25 }}>
          <Avatar sx={{ width: 32, height: 32, fontSize: 13, fontWeight: 600, bgcolor: 'primary.dark' }}>
            {initials(account.name)}
          </Avatar>
          <ListItemText primary={account.name} secondary={account.role}
                        primaryTypographyProps={{ noWrap: true, fontWeight: account.current ? 600 : 400 }}
                        secondaryTypographyProps={{ noWrap: true }} />
          <ListItemIcon sx={{ justifyContent: 'flex-end', minWidth: 24 }}>
            {switching === account.id && <CircularProgress size={18} />}
            {account.current && switching === null && <CheckIcon fontSize="small" color="primary" />}
          </ListItemIcon>
        </MenuItem>
      ))}
      {error && (
        <Box>
          <Divider />
          <Typography variant="body2" color="error" sx={{ px: 2, py: 1 }}>{error}</Typography>
        </Box>
      )}
    </Menu>
  );
}
